"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.em = exports.rem = void 0;
var BASE_FONT_SIZE;

var ConvertToEms =
/** @class */
function () {
  function ConvertToEms() {
    this.config = function (fontSize) {
      BASE_FONT_SIZE = fontSize;
    };
  }

  return ConvertToEms;
}();

var stripUnit = function stripUnit(value) {
  return value / (value * 0 + 1);
};

var calcSize = function calcSize(pixelVal, base, unit) {
  var auxPixelVal = pixelVal;
  var auxBase = base;
  if (isNaN(pixelVal)) auxPixelVal = stripUnit(pixelVal);
  if (isNaN(base)) auxBase = stripUnit(base);
  if (isNaN(auxPixelVal / auxBase)) return;
  return "calc(" + auxPixelVal / auxBase + " * 1" + unit + ")";
};

var rem = function rem(pixelVal, base) {
  if (base === void 0) {
    base = BASE_FONT_SIZE;
  }

  return calcSize(pixelVal, base, 'rem');
};

exports.rem = rem;

var em = function em(pixelVal, base) {
  if (base === void 0) {
    base = BASE_FONT_SIZE;
  }

  return calcSize(pixelVal, base, 'em');
};

exports.em = em;
exports.default = ConvertToEms;